export let ExperimentKeys;
(function (ExperimentKeys) {
  ExperimentKeys["ACQ0157"] = "acq-0157";
  ExperimentKeys["ACQ0162"] = "acq-0162";
})(ExperimentKeys || (ExperimentKeys = {}));
export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';